function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M33,20.20711v1H30v-1Zm-18,0v1H12v-1Zm19-1H24v8H34Zm-18,0H6v8H16Zm10-8.41421,6.414,6.414L36,17.2071v3.99979l1,.00022v2l-1-.00022v6.00022H22V23.20689H18v6.00022H4V23.20689l-1,.00022v-2l1-.00022V17.2071l3.585-.00021L14,10.79289,16.70711,13.5l-1.41422,1.41421L13.999,13.6211l-3.586,3.58579L18,17.2071v3.99979h4V17.2071l7.586-.00021L26.0004,13.6211l-1.29329,1.29311L23.29289,13.5Z"
});

var SvgExpert = function SvgExpert(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgExpert, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/expert.2f14b3c7.svg";
export { ForwardRef as ReactComponent };